import React from 'react';
import { ThermometerSnowflake, Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-muted/50 border-t" data-id="element-295">
      <div className="container mx-auto px-4 py-12 md:px-6 lg:py-16" data-id="element-296">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4" data-id="element-297">
          {/* Company Info */}
          <div className="space-y-4" data-id="element-298">
            <div className="flex items-center gap-2" data-id="element-299">
              <img src="https://cdn.magicpatterns.com/uploads/1Stki6WQT8fun4qYjVmCAY/sunflow-primary-logo-full-color-rgb-900px-w-72ppi.png" alt="SunFlow Heated Driveways" className="h-12 w-auto" data-id="element-300" />
            </div>
            <p className="text-sm text-muted-foreground" data-id="element-301">
              Professional heated driveway installation and outdoor heating
              systems across Ontario. Keep your home safe and accessible all
              winter long.
            </p>
            <div className="flex gap-4" data-id="element-302">
              <a href="https://www.facebook.com/hellosunflow" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary" data-id="element-303">
                <Facebook className="h-5 w-5" data-id="element-304" />
                <span className="sr-only" data-id="element-305">Facebook</span>
              </a>
              <a href="https://www.instagram.com/sunflowsolarandexteriors/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary" data-id="element-306">
                <Instagram className="h-5 w-5" data-id="element-307" />
                <span className="sr-only" data-id="element-308">Instagram</span>
              </a>
            </div>
          </div>

          {/* Services */}
          <div data-id="element-309">
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider" data-id="element-310">
              Services
            </h3>
            <ul className="space-y-3 text-sm text-muted-foreground" data-id="element-311">
              <li data-id="element-312">Heated Driveways</li>
              <li data-id="element-313">Heated Walkways</li>
              <li data-id="element-314">Patio Heating</li>
              <li data-id="element-315">Snow Melting Systems</li>
              <li data-id="element-316">System Maintenance</li>
            </ul>
          </div>

          {/* Service Areas */}
          <div data-id="element-317">
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider" data-id="element-318">
              Service Areas
            </h3>
            <ul className="space-y-3 text-sm text-muted-foreground" data-id="element-319">
              <li data-id="element-320">Toronto & GTA</li>
              <li data-id="element-321">Ottawa</li>
              <li data-id="element-322">Hamilton</li>
              <li data-id="element-323">London</li>
              <li data-id="element-324">Barrie & Simcoe</li>
              <li data-id="element-325">All of Ontario</li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-326">
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider" data-id="element-327">
              Contact Us
            </h3>
            <ul className="space-y-3 text-sm text-muted-foreground" data-id="element-328">
              <li className="flex items-start gap-2" data-id="element-329">
                <MapPin className="h-5 w-5 shrink-0 text-primary" data-id="element-330" />
                <span data-id="element-331">30 Quarry Ridge Rd, Barrie, ON L4M 7G1</span>
              </li>
              <li className="flex items-center gap-2" data-id="element-332">
                <Phone className="h-5 w-5 shrink-0 text-primary" data-id="element-333" />
                <a href="tel:647-706-9908" className="hover:text-primary" data-id="element-334">
                  (647) 706-9908
                </a>
              </li>
              <li className="flex items-center gap-2" data-id="element-335">
                <Mail className="h-5 w-5 shrink-0 text-primary" data-id="element-336" />
                <a href="mailto:sales@sunflowheateddriveways.com" className="hover:text-primary" data-id="element-337">
                  sales@sunflowheateddriveways.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t pt-8 text-center text-sm text-muted-foreground" data-id="element-338">
          <p data-id="element-339">
            &copy; {new Date().getFullYear()} SunFlow Heated Driveways. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}